'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$28() {
  this.bBw = null;
  this.bBx = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$28 as $c_Lpresto_TwoFactorAuthView$$anon$28 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$28;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$28() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$28 as $h_Lpresto_TwoFactorAuthView$$anon$28 };
$h_Lpresto_TwoFactorAuthView$$anon$28.prototype = $p;
$p.P = (function() {
  if ((!this.bBx)) {
    this.bBw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bBx = true;
  }
  return this.bBw;
});
var $d_Lpresto_TwoFactorAuthView$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$28, "presto.TwoFactorAuthView$$anon$28", ({
  So: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$28 as $d_Lpresto_TwoFactorAuthView$$anon$28 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$28.js.map
